import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import styled from 'styled-components';

export const SettingsSideBarTitle = styled(PocTypography).attrs({ variant: 'subtitle1' })`
    padding-top: 1rem;
    padding-left: 1rem;
    color: var(--one-color-foreground-intensity-medium, #868281);
`;

export const SettingsViewLayout = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 40px;
`;

export const SettingsViewHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px 0;
    min-height: 6.5rem;
    padding: 15px 0 15px 10px;
`;

export const TitleWithOptions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const SettingsViewContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
    width: 100%;
`;

export const SettingsLoadingContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

export const SettingsCardLayout = styled(PocCard)`
    background-color: #fff !important;

    /* OWC-OVERRIDE: v6's 24px card padding. owc-card's content wrapper ships with zero padding
       in v7.6.0 and exposes no padding prop. */
    .owc-card__content-wrapper {
        padding: 24px;
    }

    owc-component-header {
        flex-wrap: wrap;
        height: auto;
        padding: 20px 24px 0 !important;
        border: none !important;

        div {
            overflow: unset !important;
        }

        .last-sync-status {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding-left: 20px;
        }
    }

    owc-component-footer {
        padding: 0 24px 24px !important;
    }
`;
